import { useEffect } from 'react';
import { 
  useSetOnboardingStage,
  useSetUserCountry,
  useSetSignupMethod,
  useSetDisplayName,
  useSetCryptoOnboardingComplete,
  useSetMoneyType,
  useSetQrCode,
  useSetQrCodeLink,
  useSetStripeOnboardingStatus
} from '../state';
import { getUserData } from '../services';

const CheckOnboardingStage = () => {
  const setOnboardingStage = useSetOnboardingStage();
  const setUserCountry = useSetUserCountry();
  const setSignupMethod = useSetSignupMethod();
  const setDisplayName = useSetDisplayName();
  const setCryptoOnboardingComplete = useSetCryptoOnboardingComplete();
  const setMoneyType = useSetMoneyType();
  const setQrCode = useSetQrCode();
  const setQrCodeLink = useSetQrCodeLink();
  const setStripeOnboardingStatus = useSetStripeOnboardingStatus();

  useEffect(() => {
    const fetchOnboardingStage = async () => {
      try {
        const data = await getUserData(['onboardingStage', 'country', 'signupMethod', 'displayName', 'stripeOnboardingComplete', 'lightningAddress', 'moneyType', 'qrCode', 'qrCodeLink', 'stripeOnboardingStatus']);

        console.log('Onboarding stage: ', data.onboardingStage);
        
        // Set both onboarding stage and country if available
        setOnboardingStage(data.onboardingStage);
        if (data.country) {
          setUserCountry(data.country);
        }
        if (data.signupMethod) {
          setSignupMethod(data.signupMethod);
        }
        if (data.displayName) {
          setDisplayName(data.displayName);
        }
        if (data.stripeOnboardingStatus) {
          setStripeOnboardingStatus(data.stripeOnboardingStatus);
        }
        if (data.lightningAddress) {
          setCryptoOnboardingComplete(true);
        }
        if (data.moneyType) {
          setMoneyType(data.moneyType);
        }
        if (data.qrCode) {
          setQrCode(data.qrCode);
        }
        if (data.qrCodeLink) {
          setQrCodeLink(data.qrCodeLink);
        }
      } catch (error) {
        console.error('Error fetching onboarding stage:', error);
        setOnboardingStage('select-country'); // Default to select-country if fetch fails
      }
    };

    fetchOnboardingStage();
  }, [setOnboardingStage, setUserCountry]);

  return null; // This component doesn't render anything
};

export default CheckOnboardingStage;
